var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.851 11.038a2.906 2.906 0 1 0 4.11 4.11l1.768-1.768a.844.844 0 0 1 1.194 1.193l-1.768 1.768a4.594 4.594 0 1 1-6.497-6.496l1.768-1.768A.844.844 0 0 1 6.619 9.27zm3.227-4.42a.844.844 0 0 1 0-1.193l1.767-1.767a4.594 4.594 0 0 1 6.497 6.496l-1.768 1.768a.844.844 0 1 1-1.193-1.193l1.768-1.768a2.906 2.906 0 0 0-4.11-4.11L9.27 6.619a.844.844 0 0 1-1.193 0m-1.236 5.345a.844.844 0 0 0 1.194 1.193l5.176-5.176a.844.844 0 0 0-1.193-1.194z",
    clipRule: "evenodd"
  })));
};
export { SvgLink as ReactComponent };